import React from 'react';
import MessageBox from '../../../components/MessageBox';

function Message({ type, children }) {
  return (
    <div className="contact-form__notification">
      <MessageBox size={'small'} type={type}>
        {children}
      </MessageBox>
    </div>
  );
}

export default function Notification({
  user,
  upgradeRequired,
  contactType,
  localisations,
  siteName,
}) {
  const phoneOrMessage =
    contactType == 'phone'
      ? `${localisations.cannot_access_telephone_number}`
      : `${localisations.message_not_sent_yet}`;
  if (upgradeRequired) {
    return user && user.just_signed_up ? (
      <Message type={'warning'}>
        {localisations.registered_with_success} {siteName}, {phoneOrMessage}.{' '}
        {localisations.you_need_to_upgrade}
      </Message>
    ) : user && user.just_signed_in ? (
      <Message type={'warning'}>
        {localisations.logged_in_with_success} {siteName}, {phoneOrMessage}.{' '}
        {localisations.you_need_to_upgrade}
      </Message>
    ) : (
      <Message type={'info'}>{localisations.you_need_to_upgrade}</Message>
    );
  }
  return null;
}
